import { Cookies } from 'react-cookie';

import { UnmountedSignsResponse } from './types';

import axiosInterceptor from 'api/interceptor/axiosClient';

export const getUnmountedSigns = async (siteSlug: string) => {
  const cookies = new Cookies();
  const token = cookies.get('local_access_token');
  const response = await axiosInterceptor.get(`api/v1/site/${siteSlug}/unmounted-markers`, {
    headers: {
      Authorization: token,
    },
  });
  return response.data as UnmountedSignsResponse;
};
